// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdleTimeoutController from "./idle_timeout_controller"
application.register("idle-timeout", IdleTimeoutController)

import LearnIndexController from "./learn_index_controller"
application.register("learn-index", LearnIndexController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import PhoneFieldController from "./phone_field_controller"
application.register("phone-field", PhoneFieldController)

import ScrollProgressController from "./scroll_progress_controller"
application.register("scroll-progress", ScrollProgressController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import WaitlistJumpController from "./waitlist_jump_controller"
application.register("waitlist-jump", WaitlistJumpController)
